const STORAGE_KEY = 'digitalEscapeRoomAssignedPlayer';

export function readStoredPlayerAssignment() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeStoredPlayerAssignment(assignment) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(assignment));
}

export function clearStoredPlayerAssignment() {
  localStorage.removeItem(STORAGE_KEY);
}
